<div
    #mapContainer
    class="territory-map"
    [style.min-height]="mapMinHeight()"
    [style.border-radius]="borderRadius()"
    [style.overflow]="'hidden'"></div>

@if (showTerritoryOverlapModal()) {
    <app-confirmation-modal
        [isVisible]="showTerritoryOverlapModal()"
        type="warning"
        [title]="'Territory Overlap'"
        [confirmText]="'Yes'"
        [message]="warningMessage()"
        (modalClose)="closeTerritoryOverlapModal()"
        (confirm)="closeTerritoryOverlapModal()" />
}
